import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4c8901d6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container text-center" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-center display-4" }, "Newsletter", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Subscribe to our newsletter to receive the latest updates about Logic World!", -1))
const _hoisted_5 = { class: "row" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-3" }, null, -1))
const _hoisted_7 = { class: "col-md-6" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-3" }, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-row justify-content-center" }, [
  /*#__PURE__*/_createElementVNode("p", {
    class: "mt-3",
    style: {"max-width":"700px"}
  }, [
    /*#__PURE__*/_createTextVNode("We don't do any of the typical email marketing mischief. We have no tracking pixels, we use minimal HTML, and everybody gets the same links -- no special, individual links that let us know when you click on them. They're just regular emails."),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("We promise to keep your email address private.")
  ])
], -1))

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_TitleTag = _resolveComponent("TitleTag")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_TitleTag, { title: "Newsletter" }),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.authed ? 'NewsletterAuthed' : 'NewsletterAnon')))
        ]),
        _hoisted_8
      ]),
      _hoisted_9
    ])
  ], 64))
}